import {
  LitElement,
  html,
  utils,
  disableBodyScroll,
  enableBodyScroll,
} from '@hh/global.js'

class HHHeader extends LitElement {
  static properties = {
    hasOpenModal: {
      type: Boolean,
      reflect: true,
    },
    transparent: {
      type: Boolean,
    },
  }
  constructor() {
    super()
    this.addEventListener('modalOpened', () => (this.hasOpenModal = true))
    this.addEventListener('modalClosed', () => (this.hasOpenModal = false))

    window.addEventListener('scroll', this.handleScroll.bind(this))

    this.handleScroll()
  }

  addHeaderOffsetVariable() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.parentElement.offsetHeight * 0.1}rem`
    )
    document.documentElement.style.setProperty(
      '--header-width',
      `${this.parentElement.offsetWidth * 0.1}rem`
    )
    document.documentElement.style.setProperty(
      '--window-height',
      `${window.innerHeight}px`
    )
    const headerSearch = this.querySelector('.mobile-menu__search')
    if (headerSearch) {
      document.documentElement.style.setProperty(
        '--header-search-height',
        `${headerSearch.offsetHeight * 0.1}rem`
      )
    }
  }

  firstUpdated() {
    this.addHeaderOffsetVariable()
    window.addEventListener('resize', this.addHeaderOffsetVariable.bind(this))
  }

  handleScroll() {
    if (this.transparent) {
      const hero = document.querySelector('.hero[index="1"]')
      if (hero) {
        this.classList.toggle(
          'is-scrolled',
          window.scrollY > hero.offsetTop + hero.offsetHeight
        )
      } else {
        this.classList.toggle('is-scrolled', window.scrollY > this.offsetHeight)
      }
    }
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
    !!document.body.classList.contains('mini-cart-is-active')
      ? disableBodyScroll(utils.one('hh-mini-cart'))
      : enableBodyScroll(utils.one('hh-mini-cart'))
  }

  async validateWasteNotProduct() {
    if (Shopify.country !== 'US' || !window.wasteNot) return
    try {
      const response = await fetch(`/cart.js`)
      const cartData = await response.json()
      const cartItems = cartData.items || []
      const wasteNotProductId = window.wasteNot.product

      if (cartItems.length <= 0) return

      const wasteNotProductIndex = cartItems.findIndex(
        (product) => product.id === wasteNotProductId
      )
      const wasteNotProduct = cartItems.filter(
        (product) => product.id === wasteNotProductId
      )

      if (wasteNotProduct.length > 0 && wasteNotProduct[0].quantity > 1) {
        const response = await utils.updateQuantity(wasteNotProductIndex + 1, 1)

        if (response.errors) {
          console.error(response.errors)
          return
        }

        document.activeElement.blur()
        utils.reRenderShopifySections(response)
      }
    } catch (error) {
      console.error('Error fetching cart data:', error)
    }
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
